import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../../components/table/tableCustom';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { icons } from '../../../../assets/icons/icons';
import ModalCustom from '../../../../components/modal/modalCustomCms';
import StateComponents from '../../../../components/state-component/StateComponents';
import { produce } from 'immer';
import { alertActive, alertSuccess } from '../../../../components/alert/swal';
import { BOOKING_ROOM_DATE_TYPE, day_of_weeks_data } from '../enum/enum';
import { room_meeting_day_data, room_meeting_day_list, RoomMeetingDayApi } from '../../../../api/room-meeting-day/room_meeting_day.api';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

type Props = {
    id_room_meeting: number;
}

const RoomMeetingCloseService: React.FC<Props> = ({ id_room_meeting }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [data, setData] = useState<any[]>([]);
    const [search_data, set_search_data] = useState<any>(null);
    const [id_room_meeting_day, set_id_room_meeting_day] = useState<number | null>(null);
    const [checked, setChecked] = useState<string[]>([]);


    const [is_view, set_is_view] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const defaultFormState: room_meeting_day_data = {
        day_name: "",
        id_room_meeting: null,
        room_meeting_end_date: "",
        room_meeting_start_date: "",
        room_meeting_time: "",
        type_day: BOOKING_ROOM_DATE_TYPE.SINGLE_DAY
    }
    const [formState, setFormState] = useState<room_meeting_day_data>(defaultFormState);
    const [array_date, set_array_date] = useState<{ start_time: string, end_time: string }[]>([
        {
            end_time: "",
            start_time: ""
        }
    ]);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setFormState(defaultFormState);
        set_search_data(null);
        setChecked([]);
        set_is_view(false);
        set_array_date([{ end_time: "", start_time: "" }]);
        set_id_room_meeting_day(null);
    }
    function handleChangeFormState<K extends keyof room_meeting_day_data>(
        field: K,
        value: room_meeting_day_data[K]
    ) {
        setFormState(prev =>
            produce(prev, draft => {
                draft[field] = value;
            })
        );
    }
    const handleAddRowsDate = () => {
        let new_rows: { start_time: string, end_time: string } = {
            start_time: "",
            end_time: ""
        }
        set_array_date((prev) => ([...prev, new_rows]))
    }
    type DateRange = {
        start_time: string;
        end_time: string;
    };

    function makeDateFieldChanger(
        index: number,
        field: keyof DateRange
    ) {
        return (value: string) => {
            set_array_date(prev =>
                produce(prev, draft => {
                    if (draft[index]) draft[index][field] = value;
                })
            );
        };
    }
    const headCells = [
        {
            id: "no",
            width: 50,
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ลำดับ"),
        },
        {
            id: "service_name",
            width: 100,
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("รูปแบบ"),
        },
        {
            id: "qty",
            width: 150,
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("วัน"),
        },
        {
            id: "start_date",
            width: 150,
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("วันที่เริ่มต้น"),
        },
        {
            id: "end_date",
            width: 150,
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("วันที่สิ้นสุด"),
        },
        {
            id: "action",
            width: 75,
            sortable: false,
            disablePadding: false,
            align: "start",
            class: matches && data?.length == 0,
            label: "",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { day_name, type_day, id_room_meeting_day, qty, room_meeting_start_date, room_meeting_end_date } =
            objData;

        const objRenderData = {
            key: id_room_meeting_day,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no ?? "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: type_day ? t(type_day) : "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: day_name ? day_name.split(",").map((d: string) => t(d)).join(",") : "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: room_meeting_start_date ? moment(room_meeting_start_date).format("DD-MM-YYYY") : "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: room_meeting_end_date ? moment(room_meeting_end_date).format("DD-MM-YYYY") : "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: (
                        <div className='w-full flex justify-center items-center'>
                            <OptionsButtonCustom
                                enableView
                                enableEdit
                                enableDelete
                                onDeleteClick={() => {
                                    id_room_meeting_day && handleDeleteMeetingRoomService(id_room_meeting_day)
                                }}
                                onViewClick={() => {
                                    setShowModal(true);
                                    set_is_view(true)
                                    setFormState(() => ({ ...objData, }));
                                    set_id_room_meeting_day(id_room_meeting_day)
                                }}
                                onEditClick={() => {
                                    setShowModal(true);
                                    setFormState(() => ({ ...objData, }));
                                    set_id_room_meeting_day(id_room_meeting_day)
                                }}
                            />
                        </div>
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const handleSubmit = async () => {
        const body: room_meeting_day_data = {
            day_name: checked.toString(),
            id_room_meeting: id_room_meeting,
            room_meeting_end_date: formState.room_meeting_end_date ? moment(formState.room_meeting_end_date).format("YYYY-MM-DD") : null,
            room_meeting_start_date: formState.room_meeting_start_date ? moment(formState.room_meeting_start_date).format("YYYY-MM-DD") : null,
            room_meeting_time: array_date?.length > 0 ? array_date?.map((list) => `${list.start_time}-${list.end_time}`).join(",") : "",
            type_day: formState.type_day
        }
        dispatch(setLoading());
        if (id_room_meeting_day) {
            await RoomMeetingDayApi.update(id_room_meeting_day, body).then((res) => {
                if (res.status < 300) {
                    handleCloseModal();
                    handleGetData();
                    alertSuccess(t("อัพเดตวันที่ปิดบริการ"), t("อัพเดตวันที่ปิดบริการ เรียบร้อยแล้ว"));
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await RoomMeetingDayApi.create(body).then((res) => {
                if (res.status < 300) {
                    handleCloseModal();
                    handleGetData();
                    alertSuccess(t("เพิ่มวันที่ปิดบริการ"), t("เพิ่มวันที่ปิดบริการ เรียบร้อยแล้ว"));
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }
    const handleDeleteRows = (index: number) => {
        set_array_date((prev) => prev.filter((_, i) => i !== index))
    }
    const handleDeleteMeetingRoomService = (id_room_meeting_day: number) => {
        alertActive(t("ลบรายการ"), t("ต้องการลบรายการนี้หรือไม่?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await RoomMeetingDayApi.delete(id_room_meeting_day).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess(t("ลบรายการ"), t("ลบรายการสำเร็จ"))
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }


    const handleGetData = useCallback(async () => {
        let query: room_meeting_day_list = {
            page: page,
            limit: pageLimit,
            id_room_meeting: id_room_meeting
        }
        dispatch(setLoading());
        await RoomMeetingDayApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setData(response);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading())
        })
    }, [page, pageLimit])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return (
        <section className="w-full mt-10">
            <div className='flex justify-end items-center my-4'>
                <Button onClick={() => {
                    setShowModal(true);
                }} color='success' startIcon={<icons.add2 />} variant='contained'>
                    {t("เพิ่ม")}
                </Button>
            </div>
            <div className='w-full'>
                <TableCustom
                    tableMinWidth={1040}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data?.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </div>

            {showModal && (
                <ModalCustom
                    handleClose={handleCloseModal}
                    onClick={handleSubmit}
                    open
                    title={id_room_meeting_day ? t('รายละเอียดวันที่ปิดบริการ') : t('เพิ่มวันที่ปิดบริการ')}
                    subTitle={t("กรุณาเลือกรายการที่ท่านต้องการ")}
                    scrollBody
                    disabledSubmitButton={!array_date?.some((x) => x.start_time) || !array_date?.some((x) => x.end_time)}
                    maxWidth='md'
                    hintSubmitButton={is_view}
                    form={
                        <div className='w-full py-6'>
                            <StateComponents
                                sxContainer={{ my: 2 }}
                                disabledAllField={is_view}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "RADIO",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            row: true,
                                            value: formState.type_day,
                                            onChange: (e) => {
                                                handleChangeFormState('type_day', e.target.value);
                                                setChecked([]);
                                            },
                                            dataList: [
                                                {
                                                    label: t(BOOKING_ROOM_DATE_TYPE.SINGLE_DAY),
                                                    value: BOOKING_ROOM_DATE_TYPE.SINGLE_DAY
                                                },
                                                {
                                                    label: t(BOOKING_ROOM_DATE_TYPE.RANGE),
                                                    value: BOOKING_ROOM_DATE_TYPE.RANGE
                                                },
                                            ]
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "SELECT",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            disabled: formState.type_day === BOOKING_ROOM_DATE_TYPE.RANGE,
                                            labelId: "label-select-id",
                                            options: day_of_weeks_data?.map((list) => ({
                                                label: checked.includes(list) ? "✓" + " " + t(list) : t(list),
                                                value: list,
                                            })) || [],
                                            required: true,
                                            selectId: "select-id",
                                            multiple: true,
                                            onCheckBox: (event: any) => {
                                                const {
                                                    target: { value },
                                                } = event;
                                                setChecked(typeof value === 'string' ? value.split(',') : value)
                                            },
                                            renderValue: (selected: any[]) => {
                                                const selectedLabels = day_of_weeks_data
                                                    .filter(opt => selected.includes(opt))
                                                    .map(opt => t(opt))
                                                return selectedLabels.join(", ")
                                            },
                                            value: checked,
                                            heading: t("วัน"),
                                            placeholder: t("ระบุวัน"),
                                            onChange: () => { },
                                        }
                                    }
                                ]}
                            />

                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                heading={t("วันที่")}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 6,
                                        },
                                        fieldProps: {
                                            heading: t("วันที่เริ่มต้น"),
                                            placeholder: t("ระบุวันที่เริ่มต้น"),
                                            onChange: (e) => handleChangeFormState('room_meeting_start_date', e),
                                            value: formState.room_meeting_start_date || "",
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 6,
                                        },
                                        fieldProps: {
                                            heading: t("วันที่สิ้นสุด"),
                                            placeholder: t("ระบุวันที่สิ้นสุด"),
                                            disabled: !formState.room_meeting_start_date,
                                            disableStartDate: formState.room_meeting_start_date,
                                            onChange: (e) => handleChangeFormState('room_meeting_end_date', e),
                                            value: formState.room_meeting_end_date || "",
                                        }
                                    },
                                ]}
                            />
                            <div className='flex justify-start items-center gap-4'>
                                <Button onClick={handleAddRowsDate} sx={{ p: 0.2, my: 1 }} variant='contained' color='success'>+</Button>
                                <div >{t("เวลา")}</div>
                            </div>
                            <div className='flex mt-5 flex-col gap-4'>
                                {array_date?.map((list, i) => {
                                    const changeStart = makeDateFieldChanger(i, "start_time");
                                    const changeEnd = makeDateFieldChanger(i, "end_time");
                                    return (
                                        <StateComponents
                                            otherProps={{ spacing: 2 }}
                                            typeProps={[
                                                {
                                                    seq: (1 * i) + 1,
                                                    type: "TIME_PICKER",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        headingCustom: <Box>
                                                            <Button onClick={() => {
                                                                handleDeleteRows(i)
                                                            }} sx={{ p: 0 }} variant='outlined' color='error'>{t("ลบ")}</Button>
                                                        </Box>,
                                                        heading: t("เวลาเริ่มต้น"),
                                                        placeholder: t("ระบุเวลาเริ่มต้น"),
                                                        disabled: (!array_date[i - 1]?.end_time && i > 0),
                                                        disableStartTime: array_date[i - 1]?.end_time,
                                                        onChange: (e) => changeStart(e),
                                                        value: list.start_time || "",
                                                    },
                                                },
                                                {
                                                    seq: (23 * i) + 1,
                                                    type: "TIME_PICKER",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        heading: t("เวลาสิ้นสุด"),
                                                        placeholder: t("ระบุเวลาสิ้นสุด"),
                                                        disableStartTime: list.start_time,
                                                        disabled: !list.start_time,
                                                        onChange: (e) => changeEnd(e),
                                                        value: list.end_time || "",
                                                    },
                                                }
                                            ]}
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    }
                />
            )}
        </section >
    )
}

export default RoomMeetingCloseService